import "./Design/Dashboard.css"
import { useEffect, useRef, useState } from "react";
import "./Design/Dashboard.css"
import { Button } from "@mui/material";
import trainingImage from "../Photos/Training/First Step.png"
import "../Dashboard/Courses/MyCourses.css"
import { FirstStepUpdate } from "src/handler/coursehandler";

const Training = () => {
    const [videoPlay, setVideoPlay] = useState("training");
    const playerRef = useRef<HTMLVideoElement | null>(null);
    const changes = async() => {
        if (playerRef.current) {
            await FirstStepUpdate({
                "currentVideoDurationInSeconds": playerRef.current.currentTime,
                "totalVideoDurationInSeconds": playerRef.current.duration
            }, userInformationId)
        }
    }
    const changesOnLoad = async() => {
        if (playerRef.current) {
            var responseData = await FirstStepUpdate({
                "currentVideoDurationInSeconds": playerRef.current.currentTime,
                "totalVideoDurationInSeconds": playerRef.current.duration
            }, userInformationId)
            if (responseData.statusCode === 200) {


                setTimeout(() => {
                    if (playerRef.current) {
                        playerRef.current.currentTime = responseData.data.currentVideoDuration;
                    }
                }, 10);
            }
        }
    }
    const [userInformationId,   setUserInformationId] = useState(0);
    const runOnce = useRef(false); // Ref to ensure effect runs only once

    useEffect(() => {
        if (runOnce.current === false) {
            const storedProfile = localStorage.getItem("userProfile");
            const userProfile = JSON.parse(storedProfile ?? "");
            setUserInformationId(userProfile.userInformationId);
            runOnce.current = true;
        }
    }, [runOnce])
    return <>
        <>
            <section className="headerBackgroundReverse" style={{ padding: "30px 5px", background: "" }}>
                <h3 style={{ textAlign: "center", color: "white", background: "black", padding: "10px", borderRadius: "8px" }}>Training</h3>
                <div style={{ background: "black", borderRadius: "10px", padding: "10px" }}>
                    {
                        videoPlay === "training" &&
                        <>
                            <div>
                                <h5 style={{ textAlign: "center", background: "black", color: "white" }}>First Step Meeting</h5>
                                <Button onClick={() => { setVideoPlay("firstStep") }}
                                    className='slide-item px-3'
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        padding: "0",
                                        position: "relative",
                                        display: "block",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    <div>
                                        <img className="trainingImage" src={trainingImage} />
                                    </div>
                                    <div
                                        style={{
                                            backgroundColor: "rgba(255, 255, 255, 0.8)",  // Slightly transparent white background for readability
                                            width: "100%",
                                            textAlign: "left",
                                            color: "black"
                                        }}
                                    >
                                        <h5 style={{ textAlign: "center", background: "", color: "black", fontSize: "20px" }}>
                                            Welcome to Growniverse! 'First Step to Success' guides you through the essential actions to take immediately after enrollment, setting you up for a transformative journey.
                                        </h5>
                                    </div>
                                    <h5 style={{ color: "green" }}>Start First Step</h5>
                                </Button>
                            </div>
                        </>
                    }
                    {
                        videoPlay === "firstStep" &&
                        <>
                            <Button onClick={() => { (setVideoPlay("training")); }} style={{ borderRadius: "20px", color: "white", background: "#343434" }}><i className="fa-solid fa-arrow-left"></i></Button>
                            <div style={{
                                backgroundColor: "black"
                            }}>
                                <div
                                    style={{
                                        background: "black",
                                        padding: "50px 0"
                                    }}
                                >
                                    <div>
                                        <video
                                            ref={playerRef}
                                            controls
                                            controlsList="nodownload"
                                            onContextMenu={(e) => e.preventDefault()}
                                            className="videoSelect"
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                                                background: "black",
                                                padding: "10px 10px"
                                            }}
                                            onLoadedData={() => {
                                                changesOnLoad();
                                              }}
                                            
                                            onTimeUpdate={() => {
                                                if (playerRef.current) {
                                                    const currentTime = Math.floor(playerRef.current.currentTime);
                                                    const totalTime = Math.floor(playerRef.current.duration);
                                                    if(currentTime === totalTime)
                                                    {
                                                        changes();
                                                    }
                                                    // Trigger the function if the time is a multiple of 60 seconds
                                                    if (currentTime % 60 === 0 && currentTime !== 0) {
                                                        changes();
                                                    }
                                                }
                                            }}
                                        >
                                            <source
                                                src="https://api.growniverse.com/api/Video/stream" // Replace with your .NET backend endpoint
                                                type="video/mp4"
                                            />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                    <div style={{ padding: "20px",display:"flex",justifyContent:"center",
                                        borderBottom: "1px solid #333" }}>
                                        <h3
                                            style={{
                                                fontSize: "20px",
                                                marginBottom: "10px",
                                                fontWeight: "bold",
                                                color: "white"
                                            }}
                                        >
                                            {"First Step Training"}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </section>
        </>
    </>
};

export default Training;